import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    if (!localStorage.getItem("arete_token") && !window.location.hash.includes("session_id=")) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("arete_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, phone = "", fromTrial = false) => {
    const { data } = await api.post("/auth/register", { name, email, password, phone, from_trial: fromTrial });
    localStorage.setItem("arete_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const processGoogle = async (sessionId) => {
    const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
    localStorage.setItem("arete_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("arete_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, processGoogle, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
